import { CheckCircle } from '@mui/icons-material';
import { Box, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { timeOfDayItems, weekDaysItems, weekDaysItemsES } from './DayFilters.helpers';
import { checkIconStyles, checkboxStyles, weekDaysControlLabelStyles } from '../FilterDialog/FilterDialog.styles';
export default function DayFilters({
  threeDaySwitch,
  timeOfDay,
  setTimeOfDay,
  weekDays,
  setWeekDays
}: Readonly<{
  threeDaySwitch: boolean;
  setTimeOfDay: (timeOfDay: string) => void;
  setWeekDays: (weekDays: string[]) => void;
  weekDays: string[];
  timeOfDay: string;
}>) {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (weekDays.includes(value)) {
      const newArray = weekDays.filter(item => item !== value);
      setWeekDays(newArray);
    } else {
      setWeekDays([...weekDays, value]);
    }
  };
  const router = useRouter();
  const {
    locale
  } = router;
  const {
    t
  } = useTranslation('dateAndTime');
  useEffect(() => {
    if (threeDaySwitch) {
      setWeekDays([]);
      setTimeOfDay('');
    }
  }, [threeDaySwitch, setWeekDays, setTimeOfDay]);
  return <Box data-sentry-element="Box" data-sentry-component="DayFilters" data-sentry-source-file="DayFilters.tsx">
			<Typography variant="header3" id="filter-title" data-sentry-element="Typography" data-sentry-source-file="DayFilters.tsx">
				{t('filterBy')}
			</Typography>
			<FormControl data-sentry-element="FormControl" data-sentry-source-file="DayFilters.tsx">
				<FormLabel data-sentry-element="FormLabel" data-sentry-source-file="DayFilters.tsx">
					<Typography variant="bodyLargeBook" color="primary.main" id="week-day" data-sentry-element="Typography" data-sentry-source-file="DayFilters.tsx">
						{t('bestDay')}
					</Typography>
				</FormLabel>
				{locale === 'en-US' && <Grid container spacing={2} mt={1} mb={4} ml={0} aria-labelledby="week-day">
						{weekDaysItems.map(({
          value,
          label
        }) => {
          const selected = weekDays.includes(value);
          return <Grid item key={value}>
									<FormControlLabel sx={weekDaysControlLabelStyles(selected)} control={<>
												{selected ? <CheckCircle sx={checkIconStyles} /> : null}
												<Checkbox sx={checkboxStyles} icon={<Typography variant="bodyMediumBook">{label}</Typography>} checkedIcon={<Typography variant="bodyLargeBold">{label}</Typography>} inputProps={{
                'aria-label': value,
                'data-test-id': `checkbox_filter_${value}`
              } as React.InputHTMLAttributes<HTMLInputElement>} onChange={handleCheckboxChange} value={value} checked={selected} />
											</>} label={null} />
								</Grid>;
        })}
					</Grid>}
				{locale === 'es-US' && <Grid container spacing={2} mt={1} mb={4} ml={0} aria-labelledby="week-day">
						{weekDaysItemsES.map(({
          value,
          label
        }) => {
          const selected = weekDays.includes(value);
          return <Grid item key={value}>
									<FormControlLabel sx={weekDaysControlLabelStyles(selected)} control={<>
												{selected ? <CheckCircle sx={checkIconStyles} /> : null}
												<Checkbox sx={checkboxStyles} icon={<Typography variant="bodyMediumBook">{label}</Typography>} checkedIcon={<Typography variant="bodyLargeBold">{label}</Typography>} inputProps={{
                'aria-label': value,
                'data-test-id': `checkbox_filter_${value}`
              } as React.InputHTMLAttributes<HTMLInputElement>} onChange={handleCheckboxChange} value={value} checked={selected} />
											</>} label={null} />
								</Grid>;
        })}
					</Grid>}
				<FormLabel id="time-of-day" data-sentry-element="FormLabel" data-sentry-source-file="DayFilters.tsx">
					<Typography variant="bodyLargeBook" color="primary.main" data-sentry-element="Typography" data-sentry-source-file="DayFilters.tsx">
						{t('whatTimeDay')}
					</Typography>
				</FormLabel>
				<RadioGroup row aria-labelledby="time-of-day" value={timeOfDay} onChange={e => setTimeOfDay(e.target.value)} data-sentry-element="RadioGroup" data-sentry-source-file="DayFilters.tsx">
					{timeOfDayItems.map(({
          value,
          label
        }) => <FormControlLabel key={value} value={value} control={<Radio inputProps={{
          'data-test-id': `radio_filter_${value}`
        } as React.InputHTMLAttributes<HTMLInputElement>} />} label={label} />)}
				</RadioGroup>
			</FormControl>
		</Box>;
}